import Container from "../../components/ui/Container";
import PrivacyPolicy from "../../components/PrivacyPolicy/PrivacyPolicy";

const PrivacyPolicyPage: React.FC = () => {
    return (
         <Container>
            <PrivacyPolicy/>
        </Container>
    );
}
export default PrivacyPolicyPage;